const CryptoJS = require("crypto-js");

exports.getQueryVariable = function (variable) {
    const query = window.location.search.substring(1);
    //console.log(query);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        if (pair[0] === variable) {
            return pair[1];
        }
    }
    return null;
}


exports.encrypt = function encryptData(text) {
    const key = "H_#!ar1f5i2b1rQe";
    const encrypted = CryptoJS.AES.encrypt(text, key);
    return encrypted.toString();
};


exports.decrypt = function decryptData(text) {
    const key = "H_#!ar1f5i2b1rQe";
    const decrypted = CryptoJS.AES.decrypt(text, key);
    return decrypted.toString(CryptoJS.enc.Utf8);
};

exports.iosOrAndroid = function () {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    let rsp = null;
    if (isAndroid) {
        rsp = "android"
    }
    if (isIOS) {
        rsp = "ios"
    }

    return rsp
}

exports.isSafari = function () {
    let userAgent = navigator.userAgent;

    if (userAgent.indexOf("Safari") > -1) {
        console.log("isSafari");
        return "true";
    }else {
        console.log("noSafari");
        return "false"

    }
}



exports.isPhoneNumber = function (phoneNo) {
    let regPhone = new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)
    if (phoneNo.length>0 && regPhone.test(phoneNo)) {
        return true;
    }else {
        return false;
    }
}
